import isEmpty from '#src/client/common/utils/isEmpty.js';
import { splitProps } from 'solid-js';
import style from '#src/client/common/layout/Items.module.css';

const types = [
    'vertical', // default
    'horizontal',
    'wrap',
];

const gaps = {
    none: '0',
    small: '0.2rem',
    medium: '0.4rem',
    default: '0.8rem',
    large: '1.2rem',
    massive: '1.6rem',
    enormous: '2rem',
};

// Extra classes as necessary
const extras = [
    'alignCenter', // align-items: center;
    'alignFlexStart', // align-items: flex-start;
    'alignFlexEnd', // align-items: flex-end;
    'alignBaseline', // align-items: baseline;
    'justifyCenter', // justify-content: center;
    'justifyFlexEnd', // justify-content: flex-end;
    'justifySpaceBetween', // justify-content: space-between;
    'directionRowReverse', // flex-direction: row-reverse;
];

/**
 * @typedef ItemsProps
 * @type {object}
 * @property {('vertical'|'horizontal'|'wrap')} [type] - how to arrange the items (default: vertical)
 * @property {('none'|'small'|'medium'|'large'|'massive')} [size] - the spacing between items (default: 16px)
 * @property {('alignCenter'|'alignFlexStart'|'alignFlexEnd'|'alignBaseline'|'justifyCenter'|'justifyFlexEnd'|'justifySpaceBetween'|'directionRowReverse')[]} [extra] - array of strings describing more detail for the arrangement of items
 */

/**
 * @param {ItemsProps} props
 */
function Items(props) {
    const [local, others] = splitProps(props, [
        'type',
        'size',
        'extra',
        'class',
    ]);

    const type = () => {
        return types.includes(local.type) ? style[local.type] : style.vertical;
    };

    const gap = () => {
        const size = !isEmpty(local.size) ? local.size : gaps.default;
        return gaps[size] || size;
    };

    const extraClasses = () => {
        const extra = local.extra ?? [];
        return extra.filter((item) => {
            return extras.includes(item);
        }).map((item) => {
            return style[item];
        });
    };

    const classes = () => {
        return [
            local.class,
            style.items,
            type(),
            ...extraClasses(),
        ].join(' ');
    };

    return (
        <span
            {...others}
            style={{ '--gap': gap() }}
            class={classes()}>{props.children}</span>
    );
}

export default Items;
